import { useEffect, useState } from 'react';
import { fetchCurrentFtblClub } from 'shared/helpers/fetchCurrentFtblClub';
import { AppTester } from 'supporting';

export const useFtblCurrentClub = (accountId?: string, lang = 'ru') => {
  const [clubName, setClubName] = useState<string | null>(null);
  const [clubTeamId, setClubTeamId] = useState<string | null>(null);

  useEffect(() => {
    if (!AppTester.isFtbl() || !accountId) {
      setClubName(null);
      setClubTeamId(null);
      return;
    }

    fetchCurrentFtblClub(accountId, lang)
      .then((club) => {
        setClubName(club?.name || null);
        setClubTeamId(club?.teamId || null);
      })
      .catch(() => {
        setClubName(null);
        setClubTeamId(null);
      });
  }, [accountId, lang]);

  return { clubName, clubTeamId };
};
import { useEffect, useState } from 'react';
import { fetchCurrentFtblClub } from 'shared/helpers/fetchCurrentFtblClub';
import { AppTester } from 'supporting';

export const useFtblCurrentClub = (accountId?: string, lang = 'ru') => {
  const [clubName, setClubName] = useState<string | null>(null);
  const [clubTeamId, setClubTeamId] = useState<string | null>(null);

  useEffect(() => {
    if (!AppTester.isFtbl() || !accountId) {
      setClubName(null);
      setClubTeamId(null);
      return;
    }

    fetchCurrentFtblClub(accountId, lang)
      .then((club) => {
        setClubName(club?.name || null);
        setClubTeamId(club?.teamId || null);
      })
      .catch(() => {
        setClubName(null);
        setClubTeamId(null);
      });
  }, [accountId, lang]);

  return { clubName, clubTeamId };
};
